import TopTitle from "../components/TopTitle";
import Logo from "../assets/img/logo.png";

function AboutUs() {
  return (
    <div className="main-content">
      <TopTitle title="Misión y Visión" />
      <section className="bg-light">
        <div className="container">
          <div className="row align-items-center justify-content-center py-2">
            <div className="col-md-6 text-center">
              <img src={Logo} alt="IUTA Logo" className="img-fluid" />
            </div>
            <div className="col-md-6 p-4">
              <h3>Misión</h3>
              <p>
                Formar integralmente técnicos superiores universitarios con calidad y excelencia para que contribuyan en forma
                activa y con un alto sentido ético, al desarrollo económico y social en los ámbitos local, nacional y regional del país.
              </p>
              <h3 className="mt-5">Visión</h3>
              <p>
                Hacer del IUTA un instituto universitario de excelencia, líder en la formación de técnicos superiores universitarios.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;